import styled from 'styled-components'


export const Container = styled.div`
display: flex;
flex:1;
align-items: center;
justify-content: flex-start;
width: 100%;
height: 100%;
background-color: ${(props) => props.colorContent};
padding: 10px;
border-radius: 3px;

color: ${(props) => props.colorContent === '#EBECEC' ? '#343A40' : props.colorContent !== '#EBECEC' ? '#FFF' : null};
`

export const IconEnd = styled.i`
  position:absolute;
  right: 5px;
`;